import react, { useState, useMemo, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const REACT_APP_API_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";

const PaymentReturn = (props) => {
  const [successfulPayment, setSuccessfulPayment] = useState(false);
  const [timeoutComplete, setTimeoutComplete] = useState(false);
  const [checkPaymentCounter, setCheckPaymentCounter] = useState(0);
  const [receiptURL, setReceiptURL] = useState("");
  const { zeroReceipt } = props;

  function useQuery() {
    const { search } = useLocation();

    return useMemo(() => new URLSearchParams(search), [search]);
  }

  let query = useQuery();
  
  let stripe_checkout_session_id = query.get("session_id");

  const getPaymentStatus = async (theCheckPaymentCounter = 0) => {
    const callCheckoutSessionStatusReturn = await fetch(REACT_APP_API_URL+'/stripe/session-status', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
                stripe_checkout_session_id: stripe_checkout_session_id,
            })
        })

    const data = await callCheckoutSessionStatusReturn.json();

    setCheckPaymentCounter(theCheckPaymentCounter);
    setReceiptURL(data.receipt_url || "");
    
    if(data.payment_status === 'paid' || data.paid) {
        setSuccessfulPayment(true);
    } else {
        setSuccessfulPayment(false);
        setTimeout(() => {
            setTimeoutComplete(true);
            if(theCheckPaymentCounter < 5) {
                getPaymentStatus(theCheckPaymentCounter + 1);
            }
        }, 6000); // Set timeout to 6 seconds
    }

    return true;

  }

  const handleScheduleClick = () => {
    window.open("https://calendly.com/chris-c-solutionsauto/detailing-carwash", "_blank");
    }


  useEffect(() => {
    if(stripe_checkout_session_id) {
        getPaymentStatus();
    } else {
        setTimeoutComplete(true);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const showReceipt = () => {
    window.open(receiptURL, "_blank");
  }

  const handleBackClick = () => {
    if(zeroReceipt) {
      window.location.href = "/payment-return?session_id="+stripe_checkout_session_id;
      return;
    } else {
     window.open("/", "_self");
    }
  }

    return (
        <section className="main-body-section">
            <h1>Payment Status</h1>
            {successfulPayment &&
            <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                <img onClick={() => handleBackClick()} src="https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/chris-onsite-logo-gold.png" alt="Chris Details Cars Logo" className="descriptor-image" style={{width: "120px", height: "auto"}} />
                <h2 className="lucky-font" style={{fontSize: "2rem"}}>Payment complete!</h2>
                {!zeroReceipt &&<section className="info-section">
                    <div className="actions">
                        <div className="action-btn" onClick={handleScheduleClick}>
                            <h3 className="emoji">🗓️</h3>
                            <div  style={{backgroundColor: "#333"}}>
                                Schedule
                            </div>
                        </div>
                        <div className="action-btn" onClick={() => window.open("https://g.page/r/CU_KKJnOvrS1EAI/review", "_blank")}>
                            <h3 className="emoji">🙌</h3>
                            <div style={{backgroundColor: "#333", fontSize: "12px"}}>
                                Leave Review!
                            </div>
                        </div>
                        <div className="action-btn" onClick={showReceipt}>
                            <h3 className="emoji"> ✅</h3>
                            <div style={{backgroundColor: "#333", fontSize: "12px"}}>
                                Get Receipt!
                            </div>
                        </div>
                    </div>
                </section>}
                {zeroReceipt && <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                    <h2>This one was free!</h2>
                    <img src="https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/chris-onsite-logo-gold.png" alt="Chris Details Cars Logo" className="descriptor-image" style={{width: "120px", height: "auto"}} />
                </div>}
            </div>
            }
            {!successfulPayment && (
            <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                {!timeoutComplete && (
                <>
                    <img src="https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/chris-onsite-logo-gold.png" alt="Chris Details Cars Logo" className="descriptor-image" style={{width: "120px", height: "auto"}} />
                    <h2 className="lucky-font" style={{fontSize: "2rem"}}>Looking for your payment records...</h2>
                </>
                )}
                {timeoutComplete && (
                <>
                    <p style={{fontSize: "1.5rem"}}>If you have any questions, please contact support.</p>
                    <div>
                        <button onClick={() => window.open("/", "_self")} className="cta-button lets-begin">No Payment Records Found!</button>
                    </div>
                </>
                )}
            </div>
            )}
      </section>
    );
};

export default PaymentReturn;